import { createRequestActions } from '../utils';
import * as productCategoryTRTypes from './productCategoryTRTypes';

export const saveProductCategoryTR = createRequestActions(productCategoryTRTypes.SAVE_PRODUCT_CATEGORY_TR);
export const listProductCategoryTR = createRequestActions(productCategoryTRTypes.PRODUCT_CATEGORY_TR_LIST);
